import { useTranslation } from "react-i18next";

import ActionButtonLayout from "./ActionButtonLayout";

function UpdateMaterialButtonLayout ( props ) {

    const { t } = useTranslation();

    return <ActionButtonLayout {...props}>{t("buttonName.updateMaterial")}</ActionButtonLayout>;

}

export default UpdateMaterialButtonLayout;

